document.addEventListener("DOMContentLoaded", function () {
  const trigger = document.querySelector(".rated-by-customers-inner-element");
  const popup = document.getElementById("customer-review-popup");

  if (!trigger || !popup) return;

  const closeBtn = popup.querySelector(".popup-close");
  const readAllBtn = popup.querySelector(".scroll-to-reviews");
  const root = document.documentElement;

  const openPopup = () => {
    popup.classList.add("open");
    document.body.classList.add("active-customer-review-popup");
    root.classList.add("overflow-locked", "popup-active");
  };

  const closePopup = () => {
    popup.classList.remove("open");
    document.body.classList.remove("active-customer-review-popup");
    root.classList.remove("overflow-locked", "popup-active");
  };

  trigger?.addEventListener("click", () => {
    openPopup();
  });

  closeBtn.addEventListener("click", () => {
    closePopup();
  });

  window.addEventListener("click", function (e) {
    if (!popup.contains(e.target) && !trigger.contains(e.target)) {
      closePopup();
    }
  });

  readAllBtn.addEventListener("click", function () {
    closePopup();
    document.querySelector(".okeReviews.okeReviews--theme.js-okeReviews")?.scrollIntoView({ behavior: "smooth" });
  });
});
